var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstMoveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#B6C5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 19C28.5 18.1716 27.8284 17.5 27 17.5C26.1716 17.5 25.5 18.1716 25.5 19H28.5ZM25.5 64.5C25.5 65.3284 26.1716 66 27 66C27.8284 66 28.5 65.3284 28.5 64.5H25.5ZM25.5 19V64.5H28.5V19H25.5Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8785 65.3711C56.4976 65.9215 57.4457 65.8657 57.9961 65.2465C58.5465 64.6274 58.4907 63.6793 57.8715 63.1289L55.8785 65.3711ZM32.125 42.25L31.0951 41.1595C30.7893 41.4483 30.6188 41.8521 30.6252 42.2726C30.6315 42.6932 30.8141 43.0917 31.1285 43.3711L32.125 42.25ZM57.9049 19.9655C58.5072 19.3967 58.5343 18.4473 57.9655 17.8451C57.3967 17.2428 56.4473 17.2157 55.8451 17.7845L57.9049 19.9655ZM57.8715 63.1289L33.1215 41.1289L31.1285 43.3711L55.8785 65.3711L57.8715 63.1289ZM33.1549 43.3405L57.9049 19.9655L55.8451 17.7845L31.0951 41.1595L33.1549 43.3405Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstMoveIcon);
export default __webpack_public_path__ + "static/media/FirstMoveIcon.563aa2910c1f5844b79b1754f28a73cf.svg";
export { ForwardRef as ReactComponent };